angular.module("vgresiduos").controller("RelativeKpisCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios-personalizados/kpi-relativo");
		};
	}
]);
